import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Cursor2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.5045 9.04501L4.00452 3.04501C3.73107 2.94637 3.42525 3.01462 3.21969 3.22018C3.01414 3.42573 2.94588 3.73156 3.04452 4.00501L9.04452 20.505C9.15188 20.802 9.43375 20.9999 9.74952 21C10.0569 21.0003 10.3333 20.8131 10.447 20.5275L13.327 13.3275L20.527 10.4475C20.8184 10.337 21.011 10.0579 21.011 9.74626C21.011 9.43466 20.8184 9.15552 20.527 9.04501H20.5045ZM12.4721 12.045L12.1721 12.165L12.0521 12.465L9.74963 18.15L5.00213 5.00249L18.1496 9.74999L12.4721 12.045Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Cursor2.vue"]]);
